module.exports = __webpack_public_path__ + "img/settingbuttonPressed.843b33fa.png";